export class IncomeCalculatorApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getInfo() {
    return this.#http.get('/incomeCalculator');
  }
}
